<app-header></app-header>

<bit-container>
  <p>{{ "reportsDesc" | i18n }}</p>

  <app-report-list [reports]="reports"></app-report-list>
</bit-container>
